export default "__VITE_ASSET__65912d3d__"